import { render, staticRenderFns } from "./LibHomeSectionInfo.vue?vue&type=template&id=4528ea4c&scoped=true"
import script from "./LibHomeSectionInfo.vue?vue&type=script&lang=js"
export * from "./LibHomeSectionInfo.vue?vue&type=script&lang=js"
import style0 from "./LibHomeSectionInfo.vue?vue&type=style&index=0&id=4528ea4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528ea4c",
  null
  
)

export default component.exports